import React from 'react'
import '../assets/css/sub-pages.css'
import Section6 from '../pages/homepage/Section6'
// import Section3DM from '../pages/products-pages/Section3DM'
import { Helmet } from 'react-helmet'
import Section1 from '../components/features-component/Section1'
import Section2 from '../components/features-component/Section2'
import Section3 from '../components/features-component/Section3'
import Section4 from '../components/features-component/Section4'
import Section5 from '../components/features-component/Section5'
import FeaturesSlider from '../components/features-component/FeaturesSlider'
import Faqs from '../components/features-component/Faqs'
import Feature1 from '../assets/images/fin-rec-asset/Downtime/Real-Time Downtime Monitoring.webp'
import Feature2 from '../assets/images/fin-rec-asset/Downtime/Automated Store Recovery.webp'
import Feature3 from '../assets/images/fin-rec-asset/Downtime/Centralized Control Dashboard.webp'
import Feature4 from '../assets/images/fin-rec-asset/Downtime/Deep Downtime Analytics & Revenue Impact.webp'
import Play_btn from './../assets/images/play_supply.svg'
import YThumb_DC from './../assets/images/downtime-controller-voosh-video-thumbnail.webp'

const DowntimeNew = () => {

    const sec1data = {
        heading: "Voosh Downtime Controller",
        subText: "Restaurants frequently face unexpected store closures on third-party delivery apps due to factors like low driver availability, high order volumes, or technical errors—resulting in significant lost revenue. Voosh’s Downtime Controller offers precise analytics, real-time monitoring, and automated solutions to ensure your stores stay online and profitable.",
        btnText: "Start My Downtime Control",
        btnLink: "https://meetings.hubspot.com/bilal-k-s/meeting-with-bilal",
        ytVideoID: "-lD0kLM78Dk",
        thumbnail: YThumb_DC,
        thumbText: "What Is a Downtime Controller...",
        playBtn: Play_btn,
    }

    const s2SecHead = {
        subHead: "Why Downtime Controller?",
        heading: "Keep your stores running, revenues flowing.",
        p1: "Real-Time Downtime Insights",
        p2: "Automated Store Recovery",
        p3: "Centralized Dashboard Control",
        p4: "Deep Analytics",
    }

    const s2CardContents = [
        {
            id: '01',
            title: 'Real-Time Downtime Monitoring',
            image: Feature1,
            Problem: 'Stores often go offline without immediate visibility, causing unnoticed revenue losses.',
            Solution: "Voosh continuously monitors your store's status across all third-party delivery apps, instantly detecting and alerting you when unexpected downtime occurs.",
            Benefits: 'Minimize unnoticed downtime, instantly identify issues, and swiftly take corrective actions—keeping revenue steady.',
            p1: 'Spot payout discrepancies instantly',
            p2: 'Track hidden charges and adjustments clearly',
            p3: 'Automate accounting entries',
        },
        {
            id: '02',
            title: 'Automated Store Recovery',
            image: Feature2,
            Problem: 'Manual intervention to bring stores back online is slow and inefficient, prolonging downtime and revenue losses.',
            Solution: "Voosh automatically restores your store's availability across delivery platforms if unexpected downtime is detected during business hours.",
            Benefits: 'Achieve near 100% uptime, eliminate manual delays, and protect your revenue effortlessly.',
            p1: 'Identify order discrepancies in real-time',
            p2: 'Reduce manual verification processes',
            p3: 'Quickly recover lost revenue',
        },
        {
            id: '03',
            title: 'Centralized Control Dashboard',
            image: Feature3,
            Problem: 'Managing multiple delivery apps separately is complex and inefficient, causing operational stress and delayed responses.',
            Solution: "Voosh provides a single, centralized dashboard allowing you to manually or automatically manage your store's online status across every delivery app.",
            Benefits: 'Simplify your operational workflow, maintain complete control, and streamline your management processes.',
            p1: 'Automatically detect delayed or missing deposits',
            p2: 'Streamline reconciliation processes',
            p3: 'Ensure daily cash flow accuracy',
        },
        {
            id: '04',
            title: 'Deep Downtime Analytics & Revenue Impact',
            image: Feature4,
            Problem: 'Lack of insights into downtime frequency and financial impact prevents informed decision-making and operational improvement.',
            Solution: "Voosh offers detailed analytics on downtime frequency, patterns, and exact revenue loss, allowing you to clearly understand downtime causes and impacts.",
            Benefits: 'Precisely quantify lost revenue, pinpoint operational issues, and proactively improve your store’s performance.',
            p1: 'Eliminate manual journal entry',
            p2: 'Ensure precise financial records',
            p3: 'Scale effortlessly with your business',
        },
    ]

    const sec3data ={
        heading: "Misconceptions About Store Downtime",
        subHead1: "Misconception",
        p1: "Downtime primarily happens due to restaurant operational errors.",
        subHead2: "Reality",
        p2: "Downtime frequently occurs due to external factors like low driver availability, high demand during peak hours, or technical platform errors- not just internal operational mistakes.",
        btnText: "Learn Why Manual Downtime Management is Inefficient",
        btnLink: "https://meetings.hubspot.com/bilal-k-s/meeting-with-bilal",
    }

    const sec4data = {
        heading: "Why Restaurant Operators Choose Voosh",
        subHead1: "Enhanced Uptime",
        p1: "Ensure stores remain consistently online, maximizing your revenue opportunities.",
        subHead2: "Automated Recovery",
        p2: "Minimize manual tasks through intelligent automation and proactive monitoring.",
        subHead3: "Actionable Insights",
        p3: "Utilize clear analytics to continuously refine your operational efficiency.",
    }

    const sec5data = {
        heading: "Ready to eliminate unexpected downtime?",
        subText: "Schedule your personalized demo and discover how Voosh’s Downtime Controller helps maintain continuous operation and secure consistent revenue.",
        btnLink: "https://meetings.hubspot.com/bilal-k-s/meeting-with-bilal&__hstc=181257784.c6a9d1b3be4a6fd2ed9c2295680beb42.1703009108941.1746007643280.1746038291275.298&__hssc=181257784.7.1746038291275&__hsfp=1658680018",

    }

    const faq_data = [
        {
            id: '0',
            head: 'What exactly does the Downtime Controller do?',
            body: "It automatically identifies and resolves downtime issues, keeping your stores active and ensuring continuous revenue generation."
        },
        {
            id: '1',
            head: "How fast can Voosh recover my store after downtime?",
            body: "Stores are recovered immediately upon detection, significantly minimizing revenue losses."
        },
        {
            id: '2',
            head: "Can Voosh integrate with my existing systems?",
            body: "Yes, Voosh easily integrates with your current POS and third-party delivery platforms, enhancing your operational workflow."
        },
        {
            id: '3',
            head: "Is my downtime data secure with Voosh?",
            body: "Absolutely. Voosh maintains rigorous security measures to ensure your downtime and revenue data stays protected and confidential."
        }
      ]

  return (
    <div style={{ backgroundColor: '#fff' }}>
        <Helmet>
            <title>Downtime Controller: Eliminate Unexpected Store Closures</title>
            <meta name='description' content="Transform the way you manage your stores across multiple delivery platforms. Voosh offers real-time visibility into your store's operational hours, coupled with the power to directly control it. This tool is designed to significantly reduce downtime and boost your bottom line. Keep your stores always on, always earning." />
            <meta name='keywords' content='DoorDash Downtime, GrubHub Downtime, Uber Eats Downtime, Benefits Of Uptime, Boost Sales, Brand Reputation, Customer Experience, Uptime Management, Drive Sales, Increase Visibility, Store Online, Manage Downtime, Marketing Strategy, Pitfalls To Avoid, Store hours Management, Restaurant Visibility, Online Management, Third-Party Marketplaces, Third-Party Platforms, Store Timing, DoorDash, UberEats, GrubHub' />
        </Helmet>
        <Section1 datas = {sec1data} />
        <Section2 s2Contents = {s2CardContents} datas = {s2SecHead} />
        <Section3 datas = {sec3data} />
        {/* <Section3DM /> */}
        <Section4 datas = {sec4data} />
        <Section5 datas = {sec5data} />
        <FeaturesSlider />
        <Faqs datas={faq_data} />
        <Section6 />
    </div>
  )
}

export default DowntimeNew
